import { render } from "./TagPhotosView.vue?vue&type=template&id=17af4094&scoped=true"
import script from "./TagPhotosView.vue?vue&type=script&lang=js"
export * from "./TagPhotosView.vue?vue&type=script&lang=js"

import "./TagPhotosView.vue?vue&type=style&index=0&id=17af4094&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17af4094"]])

export default __exports__